export default __webpack_public_path__ + "static/media/design.915acee5.jpg";